import { enqueueSnackbar } from 'notistack';

export function successSnackbar(message: string, preventDuplicate = false): void {
    enqueueSnackbar(message, { variant: 'success', preventDuplicate });
}

export function infoSnackbar(message: string, preventDuplicate = false): void {
    enqueueSnackbar(message, { variant: 'info', preventDuplicate });
}

export function warningSnackbar(message: string, preventDuplicate = false): void {
    enqueueSnackbar(message, { variant: 'warning', preventDuplicate });
}

export function errorSnackbar(message: string, preventDuplicate = false): void {
    enqueueSnackbar(message, { variant: 'error', preventDuplicate });
}
